import * as T from './types';

export const mutations = {
  [T.EC_SET_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [T.EC_SET_CAMPAIGN]($state, data) {
    $state.campaign = data;
  },
  [T.EC_SET_TASKS]($state, list) {
    $state.tasks = list;
  },
  [T.EC_UPSERT_TASK]($state, task) {
    const idx = $state.tasks.findIndex(t => t.id === task.id);
    if (idx === -1) $state.tasks = [task, ...$state.tasks];
    else $state.tasks = $state.tasks.map(t => (t.id === task.id ? task : t));
  },
  [T.EC_REMOVE_TASK]($state, id) {
    $state.tasks = $state.tasks.filter(t => t.id !== id);
  },
  [T.EC_SET_EVENTS]($state, list) {
    $state.events = list;
  },
  [T.EC_UPSERT_EVENT]($state, event) {
    const idx = $state.events.findIndex(e => e.id === event.id);
    if (idx === -1) $state.events = [event, ...$state.events];
    else
      $state.events = $state.events.map(e => (e.id === event.id ? event : e));
  },
  [T.EC_REMOVE_EVENT]($state, id) {
    $state.events = $state.events.filter(e => e.id !== id);
  },
  [T.EC_SET_SCRIPTS]($state, list) {
    $state.scripts = list;
  },
  [T.EC_SET_WORKERS]($state, list) {
    $state.workers = list;
  },
  [T.EC_UPSERT_WORKER]($state, w) {
    const idx = $state.workers.findIndex(x => x.id === w.id);
    if (idx === -1) $state.workers = [w, ...$state.workers];
    else $state.workers = $state.workers.map(x => (x.id === w.id ? w : x));
  },
  [T.EC_REMOVE_WORKER]($state, id) {
    $state.workers = $state.workers.filter(x => x.id !== id);
  },
  [T.EC_SET_FIELD_SUMMARY]($state, data) {
    $state.fieldSummary = data;
  },
  [T.EC_SET_FIELD_BY_CITY]($state, list) {
    $state.fieldByCity = list;
  },
  [T.EC_SET_FIELD_HIERARCHY]($state, list) {
    $state.fieldHierarchy = list;
  },
  [T.EC_SET_MEDIA_ASSETS]($state, list) {
    $state.mediaAssets = list;
  },
  [T.EC_UPSERT_MEDIA_ASSET]($state, a) {
    const idx = $state.mediaAssets.findIndex(x => x.id === a.id);
    if (idx === -1) $state.mediaAssets = [a, ...$state.mediaAssets];
    else
      $state.mediaAssets = $state.mediaAssets.map(x => (x.id === a.id ? a : x));
  },
  [T.EC_REMOVE_MEDIA_ASSET]($state, id) {
    $state.mediaAssets = $state.mediaAssets.filter(x => x.id !== id);
  },
  [T.EC_SET_MAP]($state, data) {
    $state.map = data;
  },
  [T.EC_SET_PINS]($state, list) {
    $state.pins = list;
  },
  [T.EC_UPSERT_PIN]($state, p) {
    const idx = $state.pins.findIndex(x => x.id === p.id);
    if (idx === -1) $state.pins = [p, ...$state.pins];
    else $state.pins = $state.pins.map(x => (x.id === p.id ? p : x));
  },
  [T.EC_REMOVE_PIN]($state, id) {
    $state.pins = $state.pins.filter(x => x.id !== id);
  },
};
